<script lang="ts" setup>
    import { nextTick, ref, watch } from 'vue'
    import PkStreamingMarkdown from './PkStreamingMarkdown.vue'

    const props = defineProps<{
        markdown?: string
        innerClass?: string
        isDark?: boolean
    }>()

    const scrollEl = ref<HTMLDivElement>()
    const lastScrollTop = ref<number>(0)
    const stopAutoScroll = ref<boolean>(false)

    const handleScroll = () => {
        if (!scrollEl.value) {
            return
        }
        const currentScrollTop = scrollEl.value.scrollTop
        if (currentScrollTop < lastScrollTop.value) {
            const delta = lastScrollTop.value - currentScrollTop
            if (delta < 50) {
                stopAutoScroll.value = true
            }
        }
        if (currentScrollTop > lastScrollTop.value) {
            if (
                currentScrollTop ===
                scrollEl.value.scrollHeight - scrollEl.value.clientHeight
            ) {
                stopAutoScroll.value = false
            }
        }
        lastScrollTop.value = currentScrollTop
    }

    watch(
        () => props.markdown,
        async () => {
            await nextTick()
            if (scrollEl.value && !stopAutoScroll.value) {
                scrollEl.value.scrollTop = scrollEl.value.scrollHeight
            }
        },
        { immediate: true },
    )
</script>

<template>
    <div
        ref="scrollEl"
        class="overflow-auto light-scrollbar"
        @scroll="handleScroll">
        <PkStreamingMarkdown :markdown :is-dark :class="innerClass" />
    </div>
</template>
